const verification = {
  success: 'Verificado con éxito',
  warning:
    'Debe confirmar su dirección de correo electrónico para poder activar su perfil.',
}


export default verification
